import { IntlShape } from 'react-intl';
import * as Yup from 'yup';

export const billingFreeTierValidationSchema = (intl: IntlShape) =>
  Yup.object({
    name: Yup.string()
      .min(
        3,
        intl.formatMessage(
          {
            id: 'common.forms.validation.minimum',
            defaultMessage: '{minimum} characters minimum',
          },
          { minimum: 3 },
        ),
      )
      .max(
        15,
        intl.formatMessage(
          {
            id: 'common.forms.validation.maximum',
            defaultMessage: '{maximum} characters maximum',
          },
          { maximum: 15 },
        ),
      )
      .required(
        intl.formatMessage({
          id: 'common.forms.validation.required',
          defaultMessage: 'This field is required',
        }),
      ),
  });

export const billingValidationSchema = (intl: IntlShape) =>
  Yup.object({
    name: Yup.string()
      .min(
        3,
        intl.formatMessage(
          {
            id: 'common.forms.validation.minimum',
            defaultMessage: '{minimum} characters minimum',
          },
          { minimum: 3 },
        ),
      )
      .max(
        15,
        intl.formatMessage(
          {
            id: 'common.forms.validation.maximum',
            defaultMessage: '{maximum} characters maximum',
          },
          { maximum: 15 },
        ),
      )
      .required(
        intl.formatMessage({
          id: 'common.forms.validation.required',
          defaultMessage: 'This field is required',
        }),
      ),
    street: Yup.string()
      .min(
        3,
        intl.formatMessage(
          {
            id: 'common.forms.validation.minimum',
            defaultMessage: '{minimum} characters minimum',
          },
          { minimum: 3 },
        ),
      )
      .max(
        25,
        intl.formatMessage(
          {
            id: 'common.forms.validation.maximum',
            defaultMessage: '{maximum} characters maximum',
          },
          { maximum: 25 },
        ),
      )
      .required(
        intl.formatMessage({
          id: 'common.forms.validation.required',
          defaultMessage: 'This field is required',
        }),
      ),
    zipCode: Yup.string()
      .min(
        3,
        intl.formatMessage(
          {
            id: 'common.forms.validation.minimum',
            defaultMessage: '{minimum} characters minimum',
          },
          { minimum: 3 },
        ),
      )
      .max(
        8,
        intl.formatMessage(
          {
            id: 'common.forms.validation.maximum',
            defaultMessage: '{maximum} characters maximum',
          },
          { maximum: 8 },
        ),
      )
      .required(
        intl.formatMessage({
          id: 'common.forms.validation.required',
          defaultMessage: 'This field is required',
        }),
      ),
    city: Yup.string()
      .min(
        3,
        intl.formatMessage(
          {
            id: 'common.forms.validation.minimum',
            defaultMessage: '{minimum} characters minimum',
          },
          { minimum: 3 },
        ),
      )
      .max(
        15,
        intl.formatMessage(
          {
            id: 'common.forms.validation.maximum',
            defaultMessage: '{maximum} characters maximum',
          },
          { maximum: 15 },
        ),
      )
      .required(
        intl.formatMessage({
          id: 'common.forms.validation.required',
          defaultMessage: 'This field is required',
        }),
      ),
    country: Yup.string()
      .min(
        3,
        intl.formatMessage(
          {
            id: 'common.forms.validation.minimum',
            defaultMessage: '{minimum} characters minimum',
          },
          { minimum: 3 },
        ),
      )
      .max(
        25,
        intl.formatMessage(
          {
            id: 'common.forms.validation.maximum',
            defaultMessage: '{maximum} characters maximum',
          },
          { maximum: 25 },
        ),
      )
      .required(
        intl.formatMessage({
          id: 'common.forms.validation.required',
          defaultMessage: 'This field is required',
        }),
      ),
  });
